import React from "react";
import PropTypes from "prop-types";

/**
 * Komponent do aktualizacji klucza crc merchanta
 */
class P24MerchantAuthCrcKey extends React.Component {

    state = {
        merchantAuth: this.props.merchantAuth
    }

    handleSubmit = e => {
        e.preventDefault();
        this.props.onSubmit(this.state.merchantAuth);
    };

    render() {

        return (

            <div className="w3-card-4">
                <div className="w3-container w3-theme-l3">
                    <h5 className="w3-center">{this.props.title}</h5>
                </div>

                <form className="w3-container" onSubmit={this.handleSubmit}>
                    <div className="w3-bar">
                        <button
                            className="w3-btn w3-theme-dark w3-bar-item w3-right w3-margin-right"
                            type="submit"
                        >
                            {this.props.submitText}
                        </button>
                    </div>
                </form>

            </div>

        )
    }
}

//ustawienie domyslnych pol
P24MerchantAuthCrcKey.defaultProps = {
    title: 'Aktualizacja klucza CRC',
    submitText: 'Aktualizuj'
}

P24MerchantAuthCrcKey.propTypes = {
    //tytul formularza
    title: PropTypes.string.isRequired,
    //dane wejsciowe obiektu do wypelnienia
    merchantAuth: PropTypes.object.isRequired,
    //akcja zwrotna na zatwierdzenie
    onSubmit: PropTypes.func.isRequired,
    //tekst na akcji zapisz
    submitText: PropTypes.string.isRequired
}

export default P24MerchantAuthCrcKey;